/** Where the ui/ Dialog, Menu and Tooltip portal to. document.body by default;
 *  widget.js provides a node inside its shadow root, since styles there do not
 *  reach the document body (and the body's do not reach the widget). */
import { createContext, useContext } from "react";

export const PortalContainerContext = createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement {
  return useContext(PortalContainerContext) ?? document.body;
}
